import storeFactory from './storeFactory';

const store = storeFactory({});

export default store;
